import { NavLink } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import TooltipPortal from "components/common/TooltipPortal";

export default function NavItem({ item, collapsed, onNavigate }) {
  const Icon = item.icon;
  const linkRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState(null);

  const updateTooltipPosition = () => {
    if (!linkRef.current) return;
    const rect = linkRef.current.getBoundingClientRect();
    setPosition({
      left: rect.right + 10,
      top: rect.top + rect.height / 2,
    });
  };

  const handleEnter = () => {
    if (!collapsed) return;
    updateTooltipPosition();
    setShowTooltip(true);
  };

  const handleLeave = () => setShowTooltip(false);

  useEffect(() => {
    if (!showTooltip) return undefined;

    const handleViewportChange = () => updateTooltipPosition();
    window.addEventListener("scroll", handleViewportChange, true);
    window.addEventListener("resize", handleViewportChange);

    return () => {
      window.removeEventListener("scroll", handleViewportChange, true);
      window.removeEventListener("resize", handleViewportChange);
    };
  }, [showTooltip]);

  useEffect(() => {
    if (!collapsed) setShowTooltip(false);
  }, [collapsed]);

  return (
    <>
      <NavLink
        ref={linkRef}
        to={item.to}
        onClick={onNavigate}
        aria-label={collapsed ? item.label : undefined}
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}
        onFocus={handleEnter}
        onBlur={handleLeave}
        className={({ isActive }) =>
          `group relative flex items-center rounded-xl border-l-2 px-3 py-2 text-sm font-medium transition-all ${
            collapsed ? "justify-center" : "gap-3"
          } ${
            isActive
              ? "border-accent-500 bg-accent-100 text-brand-900"
              : "border-transparent text-slate-200 hover:bg-white/10 hover:text-white"
          }`
        }
      >
        <Icon className="text-lg" />
        {!collapsed && <span>{item.label}</span>}
      </NavLink>
      <TooltipPortal text={item.label} position={position} visible={showTooltip && collapsed} />
    </>
  );
}
